<template>
  <!-- View Legal basis modal template -->
  <b-modal ref="view-io" hide-footer @hide="hidePolicyModal" v-if="object">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('systems.access_control.view.title') }}
      </h4>
    </div>

    <label class="mt-3">
      {{ $t('systems.access_control.table.name') }}
    </label>
    <br>
    <span v-if="object.access_control" qid="access_control-name">
      {{ object.access_control.name }}
    </span>
    <br>

    <div v-if="object.description">
      <label class="mt-4">
        {{ $t('systems.access_control.table.description') }}
      </label>
      <br>
      <div class="text-formatted mt-minus-1 mb-minus-1"
            qid="access_control-description"
      >
        {{ object.description }}
      </div>
      <br>
    </div>

    <div v-if="object.provisioning">
      <label class="mt-4">
        {{ $t('systems.access_control.table.provisioning') }}
      </label>
      <br>
      <span qid="access-control-provisioning">
        {{ object.provisioning }}
      </span>
      <br>
    </div>

    <div v-if="object.re_certification">
      <label class="mt-4">
        {{ $t('systems.access_control.table.re_certification') }}
      </label>
      <br>
      <span qid="access-control-re_certification">
        {{ object.re_certification }}
      </span>
      <br>
    </div>

    <b-button class="mt-4 float-right"
              variant="success"
              @click="hidePolicyModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.policies.view.close') }}
    </b-button>
    <br>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'AccessControlViewModal',
    data: function() {
      return {
        error: '',
        processGroup: [],
        showInput: false,
        loadingItems: false,
        showArticleDescription: false
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showPolicyModal()
        }
      }
    },
    methods: {
      showPolicyModal() {
        let self = this
        this.$refs['view-io'].show()
      },
      hidePolicyModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-io'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
